import React from 'react'
import { flexRender, RowModel } from '@tanstack/react-table'
import noop from 'lodash/noop'
import { TableCell, TableRow, Typography } from '@mui/material'

import { getCommonPinningStyles } from './utils.ts'

export interface TableBodyProps<T> {
  rowModel: RowModel<T>
  onRowClick?(row: T): () => void
}

export const TableBodyRenderer = <T extends Record<string, any>>({
  rowModel,
  onRowClick,
}: TableBodyProps<T>): React.ReactElement => {
  return (
    <>
      {rowModel.rows.length ? (
        rowModel.rows.map((row) => {
          const interactive = !!onRowClick
          return (
            <TableRow
              key={row.id}
              onClick={interactive ? onRowClick(row.original) : noop}
              hover={interactive}
              sx={{ cursor: interactive ? 'pointer' : 'default' }}
            >
              {row.getVisibleCells().map((cell) => {
                return (
                  <TableCell key={cell.id} sx={getCommonPinningStyles(cell.column)}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                )
              })}
            </TableRow>
          )
        })
      ) : (
        <TableCell colSpan={99} sx={{ textAlign: 'center' }}>
          <Typography variant="caption" color="text.tertiary" mx={3}>
            Нет данных
          </Typography>
        </TableCell>
      )}
    </>
  )
}
